import { TriangleAlert } from 'lucide-react';

import { PortalEmptyState } from '@/modules/hiring-manager/components/portalEmptyState/PortalEmptyState';
import { supportMailto } from '@/modules/support/support';

/**
 * Replaces the whole app, PortalLayout included, so it sets the `portal`
 * class itself (like PortalLayoutSkeleton) to keep the portal's type and
 * tokens. Renders outside the router too (main.tsx), so no router links.
 */
export const ErrorBoundaryFallback = () => {
  return (
    <main className="portal bg-background flex min-h-svh items-center justify-center p-4">
      <PortalEmptyState
        className="w-full max-w-md"
        icon={TriangleAlert}
        title="Something went wrong"
        description="This page hit an unexpected error. Reload to try again, or email support if it keeps happening."
        action={{
          label: 'Reload page',
          onClick: () => window.location.reload(),
        }}
        secondaryAction={{
          label: 'Email support',
          href: supportMailto('Something went wrong in Finlay'),
        }}
      />
    </main>
  );
};
